export default "/images/11fcde6e13c07e016f113d757b52eccf.avif";